export const isValidData = (value: object | null | undefined | string): boolean =>
    !(value === null || value === "null" || value === "undefined" || value === undefined || value === "");
